import { BaseModel } from './base-model';
import { ZoneFeature } from './zones-base-interfaces';

// Base class for Balast Water Management zones
export abstract class BWMModelBase extends BaseModel
{
    abstract getBWMZones(): Promise<ZoneFeature[] | null>;
}

let BWMModel: BWMModelBase|null = null;

function setBWMModel(model: BWMModelBase)
{
    BWMModel = model;
}

export { BWMModel, setBWMModel };
